export const ticketDroppableId = 'ticket-entities-droppable';
